import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import { formatPercent } from 'utils';
import { policyColors, dummyData, dateConverter } from '../Utils';
import { tooltipStylePadded } from '../Tooltips/utils';

interface Props {
  data: Array<any>;
}

const PastPerformance = ({ data }: Props) => {
  const isDataProvided = data && data.length > 0;
  const dataToRender = isDataProvided
    ? data
    : dummyData.pastPerformanceAggregates;
  const adjustData = dataToRender.map((value: any) => {
    return {
      Existing: value.Existing ? Number(value.Existing) * 100 : null,
      Recommended: value.Recommended ? Number(value.Recommended) * 100 : null,
      date: value.date
    };
  });

  const tickCount = Math.ceil(data.length / 10);
  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        data={adjustData}
        margin={{ top: 5, right: 10, left: 0, bottom: 5 }}
      >
        <XAxis
          dataKey="date"
          interval={tickCount}
          tickFormatter={(val: string) => dateConverter(val)}
        />

        <YAxis unit="%" width={50} />
        <CartesianGrid vertical={false} strokeDasharray="3 3" />
        <Tooltip
          formatter={(val: any) => formatPercent(val)}
          contentStyle={tooltipStylePadded}
        />
        <Legend />
        <Line
          dataKey="Recommended"
          stroke={policyColors.recommended}
          strokeWidth={2}
          dot={false}
        />
        <Line
          dataKey="Existing"
          stroke={policyColors.existing}
          strokeWidth={2}
          dot={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default PastPerformance;
